export default "__VITE_ASSET__nHMelWI1__"